// extracted by mini-css-extract-plugin
module.exports = {"card":"ProductCardWrap_card__79872"};